export const AllocationPaymentReceiverAddress = '0xe610f633A09CdD44d4e86141FFeD81fA453dEa0C'
export const NFTAddress = '0xC4e1989C880A56872FD58214a8Eb1826BdccB136'
